<script>
	import { handleSubmit, parseFormdata, shuffle } from "../utils.js";
	import { api_writeForm } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";

	export let onClose;
	const form = useForm();

	let imgs = [
		"f_edward_snowden_bin_laden.png",
		"r_scientists_massive_star.png",
	];
	let img = shuffle(imgs)[0];

	const handleClick = () => {
		localStorage.setItem("modalShown", 1);
		handleSubmit($api_writeForm, parseFormdata($form));
		onClose();
	};

	let fields = [
		{
			labelName: "intervention_accuracy-prompt",
			label: "",
			options: [
				{
					type: "radio",
					value: "1_definitely_false",
					option: "Definitely false",
				},
				{
					type: "radio",
					value: "2_probably_false",
					option: "Probably false",
				},
				{
					type: "radio",
					value: "3_probably_true",
					option: "Probably true",
				},
				{
					type: "radio",
					value: "4_definitely_true",
					option: "Definitely true",
				},
			],
		},
	];
</script>

<section class="accuracy-prompt-container">
	<h1>
		Do you think this headline is <span style="color:red">accurate</span>?
	</h1>

	<img src={"img/accuracy_prompt/" + img} alt="prompt" />
	<form use:form>
		{#each fields as field}
			<div class="field-container">
				<label for={field.labelName}>{field.label} </label>
				{#each field.options as option}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={[required]}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button disabled={!$form.valid} on:click|preventDefault={handleClick}
			>Continue</button
		>
	</form>
</section>

<style>
	.accuracy-prompt-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	h1 {
		font-size: 1.3rem;
		text-align: center;
	}
	button {
		margin: auto;
		display: block;
	}
	.field-container {
		text-align: center;
		margin-top: 21px;
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1150px) {
		.option-group {
			display: block;
		}
	}
</style>
